import { z } from "zod";

/** Consent templates + signed consent forms (digital consent + e-signature). */

export const consentTemplateApiSchema = z.object({
	id: z.string().uuid(),
	clinic_id: z.string().uuid(),
	title: z.string(),
	body: z.string(),
	created_at: z.string().datetime(),
});
export type ConsentTemplateApi = z.infer<typeof consentTemplateApiSchema>;

export const createConsentTemplateInputSchema = z.object({
	title: z.string().min(1).max(200),
	body: z.string().min(1).max(20000),
});
export type CreateConsentTemplateInput = z.infer<
	typeof createConsentTemplateInputSchema
>;

export const consentFormApiSchema = z.object({
	id: z.string().uuid(),
	clinic_id: z.string().uuid(),
	patient_id: z.string().uuid(),
	visit_id: z.string().uuid().nullable(),
	title: z.string(),
	body: z.string(),
	signature_data: z.string().nullable(),
	signed_by_name: z.string().nullable(),
	signed_at: z.string().datetime().nullable(),
	created_at: z.string().datetime(),
});
export type ConsentFormApi = z.infer<typeof consentFormApiSchema>;

export const createConsentFormInputSchema = z.object({
	patient_id: z.string().uuid(),
	/** Optional visit/encounter this consent authorises. */
	visit_id: z.string().uuid().optional(),
	title: z.string().min(1).max(200),
	body: z.string().min(1).max(20000),
	/** PNG data URL of the captured signature; present when signed at creation. */
	signature_data: z.string().max(500_000).nullable().optional(),
	signed_by_name: z.string().max(200).nullable().optional(),
});
export type CreateConsentFormInput = z.infer<
	typeof createConsentFormInputSchema
>;

/** Attach/replace the signature on an existing (unsigned) consent. */
export const signConsentInputSchema = z.object({
	signature_data: z.string().min(1).max(500_000),
	signed_by_name: z.string().min(1).max(200),
});
export type SignConsentInput = z.infer<typeof signConsentInputSchema>;
